<template>
  <div class="modshow" :style="stylePageSingle">
    <el-form :model="form" ref="ruleForm">
      <template v-for="(item,index) in list">
        <!-- 复合组件 -->
        <template v-if="item">
          <template v-if="lazy==='Y'">
            <!-- 开启组件懒加载 但是也有部分组件如底部按钮不需要懒加载 -->
             <template v-if="item.commonConf &&item.commonConf[0].noLazy===1 ">
              <app-view :item="item" :key="index" :k="index"></app-view>
            </template>
            <template v-else>
              <VueLazyComponent :key="index" threshold="100px">
                <app-view :item="item" :key="index" :k="index"></app-view>
                <!-- <skeleton slot="skeleton" type="skeleton"></skeleton> -->
              </VueLazyComponent>
            </template>
          </template>
          <template v-else>
            <app-view :item="item" :formConfig="formConfig" :key="index" :form="form"></app-view>
          </template>
        </template>
      </template>
    </el-form>
  </div>
</template>

<script>
import eventHub from '@/js/event-bus/event-bus'
import Skeleton from './components/skeleton.vue'
import AppView from './appView.vue'
export default {
  name: 'cusWidge',
  components: { Skeleton, AppView },
  //  ['list', 'formConfig'],
  props: {
    pageData: { Array, Object },
    formConfig: { type: Object },
    form: {
      type: Object,
      default: () => {},
    },
    list:{
      type:Array,
      default: () => [],
    }
  },
  mixins: [],
  data() {
    return {
      selectId: '',
      currentFormPopId: '', //当前表单弹窗id
      handleType: null,
      formObj: this.$store.state.formObj,
      formShow: false,
      pageSingleConfig: {},
    };
  },
  computed: {
    lazy() {
      return process.env.VUE_APP_LAZY
    },
    stylePageSingle() {
      let obj = {};
      if (this.pageSingleConfig.backgroundUrl) {
        obj = Object.assign(obj, {
          "background-image": `url(${this.pageSingleConfig.backgroundUrl})`,
          "background-repeat": "no-repeat",
          "background-position": "center 0",
          "background-size": "100% auto",
        });
      } 
        obj = Object.assign(obj, {
          "background-color": this.pageSingleConfig.backgroundColor,
        });
      // console.log(obj);
      return obj;
    },
  },
 watch:{
   pageData: {
    handler(v) {
      if (v) {
        if (this.pageData.pageConfig) {
          this.pageSingleConfig = v.pageConfig;
        } else {
          this.pageSingleConfig = {
            name: "",
            backgroundUrl: "",
            backgroundColor: "",
          };
        }
      }
    },
    immediate: true,
    deep: true,
  }
 },
  created() {
  
  },
  mounted() {
    // console.log(this.list);
  },
  methods: {
  
  
  
  },
}
</script>
<style lang="scss">
.modshow {
  position: relative;
  height: 100%;
  // background-color: #F8F9FD;
  width: 100%;
}
</style>
